module.exports = require("event-to-promise");


//////////////////
// WEBPACK FOOTER
// external "event-to-promise"
// module id = 80
// module chunks = 0